import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {  AppraisalDetailsModelForDLorDA } from "../../all_Interfaces";


interface InitialState {
    data: AppraisalDetailsModelForDLorDA,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as AppraisalDetailsModelForDLorDA,
    error: '',
    loading: false
}

const appraisalDetailsForUSAppraisalDLorDASlice = createSlice({
    name: "appraisalDetailsForDLorDA",
    initialState,
    reducers: {
        updateAppraisalDetailsForDLorDA(state, action: PayloadAction<AppraisalDetailsModelForDLorDA>) {
            state.data = action.payload;
        },
    },
});

export const { updateAppraisalDetailsForDLorDA } = appraisalDetailsForUSAppraisalDLorDASlice.actions;

export default appraisalDetailsForUSAppraisalDLorDASlice.reducer;